import eventEmitter3 from "eventemitter3";

type RosettaEvents = "showPaywall";

// TODO: Migrate to generic subscription event bus later on
export const eventEmitter = new eventEmitter3<RosettaEvents>();
